import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
import { ClientService } from 'src/app/api/sale/client.service';
import { UbigeoService } from 'src/app/api/config/ubigeo.service';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-provider-extends',
  templateUrl: './provider-extends.component.html',
  styleUrls: ['./provider-extends.component.css']
})
export class ProviderExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();

  branchofficeSlug: string = '';
  item: FormGroup;
  checkId: any;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  required_ubigeo: boolean = false;

  // set values variables
  typeClientNatural: any = constants.CLIENT.TYPE[0];
  documentDni: any = constants.CLIENT.TYPE_DOCUMENT.DNI;
  documentRuc: any = constants.CLIENT.TYPE_DOCUMENT.RUC;

  typeDocumentSelected: any = null;
  departmentSelected: any = 0;
  provinceSelected: any = null;
  ubigeoEdit: any = null;
  imageUrl: any = null;
  fileUrlImage: any = null;

  typesclient: any = [];
  typesdocument: any = [];
  statusmarital: any = [];
  sexs: any = [];

  // ubigeo data
  departments: any = [];
  provinces: any = [];
  districts: any = [];

  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private alertifyMsg: AlertifyHelper,
    private globalService: GlobalService,
    private clientService: ClientService,
    private generalService: GeneralService,
    private ubigeoService: UbigeoService,
    public toolsService: ToolsService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.item = this.fb.group({});
    this.init();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  init() {
    this.item = this.fb.group({
      document: ['', [Validators.required]],
      fullname: ['', [Validators.required, Validators.minLength(2)]],
      tradename: [null],
      ubigeo: [null],
      address: [null],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      url_image: [null]
    });
  }

  // FUNCTIONS LOADS DATAS

  editClient(val_id:any){
    this.isEdit = true;
    this.checkId = val_id;
    this.loadData();
  }

  loadData() {
    this.init();

    this.getTypeDocument();
    this.getTypeClient();
    this.getDepartments();

    if (this.isEdit) {
      this.editData();
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.focused();
  }

  editData() {
    this.showloaderModal();
    this.clientService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          document: _item.document,
          fullname: _item.fullname,
          tradename: _item.tradename,
          ubigeo: _item.ubigeo,
          address: _item.address,
          cellphone: _item.cellphone,
          telephone: _item.telephone,
          email: _item.email,       
          url_image: _item.url_image
        });

        this.hideloaderModal();
        this.checkUbigeo();
      }
    });
  }

  getTypeClient() {
    this.generalService.listTypeClient().subscribe({
      next: (data: any) => {
        this.typesclient = data;
      }
    });
  }

  getTypeDocument() {
    this.showloaderModal();
    this.generalService.listTypeDocument().subscribe({
      next: (data: any) => {
        this.hideloaderModal();
        this.typesdocument = data;
        this.changeTypeDocument();
      }
    });
  }

  getDepartments() {
    this.ubigeoService.departments().subscribe({
      next: (data: any) => {
        this.departments = data.results;
      }
    });
  }

  getProvinces(department_code: any) {
    this.ubigeoService.provinces(department_code).subscribe({
      next: (data: any) => {
        this.provinces = data.results;
        this.provinceSelected = null;
        this.required_ubigeo = true;
        if (this.ubigeoEdit != null) {
          this.provinceSelected = this.ubigeoEdit.substr(0, 4);
        }
      }
    });
  }

  getDistricts(department_code: any) {
    this.ubigeoService.districts(department_code).subscribe({
      next: (data: any) => {
        this.districts = data.results;
        this.item.patchValue({
          ubigeo: null
        });

        if (this.ubigeoEdit != null) {
          this.item.patchValue({
            ubigeo: this.ubigeoEdit
          });
        }
      }
    });
  }

  changeTypeDocument() {
    this.typeDocumentSelected = this.toolsService.searchArrById(
      this.item.value.typedocument_id,
      this.typesdocument
    );
    // this.item.patchValue({
    //   document: null
    // });
  }

  changeDepartment() {
    this.provinceSelected = null;
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    this.provinces = [];
    this.districts = [];
    if (this.departmentSelected != 0) {
      this.getProvinces(this.departmentSelected);
    }
  }

  changeProvince() {
    this.districts = [];
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    if (this.toolsService.strToNull(this.provinceSelected) != null) {
      this.getDistricts(this.provinceSelected);
    }
  }

  checkUbigeo() {
    let ubigeo = this.item.value.ubigeo;
    if (ubigeo != null) {
      this.ubigeoEdit = ubigeo;
      this.required_ubigeo = true;
      this.departmentSelected = ubigeo.substr(0, 2);
      this.getProvinces(this.departmentSelected);
      this.getDistricts(ubigeo.substr(0, 4));
    }
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.showloaderModal();
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          this.hideloaderModal();
          if (data.success) {
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.showloaderModal();
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          this.hideloaderModal();
          if (data.success) {
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message =
      'El cliente se encuentra con estado ' +
      data.status +
      ' y en condición ' +
      data.condition;
    this.service_alert.show = true;

    if (data.district_id != '') {
      this.item.patchValue({
        ubigeo: data.district_id
      });
      this.checkUbigeo();
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);
      this.showloaderModal();
      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.clientService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.onSubmitEvent.emit(data.data);
            this.hideloaderModal();
            (<any>$('#openExtendsProvider')).modal('hide');
          }
        });
      } else {
        this.clientService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.onSubmitEvent.emit(data.data);
            this.hideloaderModal();
            (<any>$('#openExtendsProvider')).modal('hide');
          },
          error:(error:any) => {
            this.hideloaderModal();
            // console.log(error);
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  showloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_box')).style.display =
      'block';
  }

  hideloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_box')).style.display =
      'none';
  }

  close() {
    this.isEdit = false;
    this.checkId = null;
    this.item.reset();
  }

  focused() {
    setTimeout(() => {
      (<any>$('#client_document')).focus();
    }, 500);
  }
}
